import { useState } from "react";
import {
  fetchFollowUpQuestions,
  type FollowUpSource,
} from "../api/followUpQuestions";

// Follow-up suggestions for a chat surface (toggled by the caller via
// `enabled`). Owns the questions list, cleared on a new submit and refreshed
// after each completed turn. The conversation shell wires `refresh` into the
// chat's `onTurnFinish` and `clear` into its submit. `refresh`/`clear` are
// plain functions (not memoized) — they are only ever invoked from event
// callbacks, never used as effect/memo dependencies.
export function useFollowUps(opts: {
  enabled: boolean;
  source: FollowUpSource;
}): {
  questions: string[];
  clear: () => void;
  refresh: (question: string, answer: string) => void;
} {
  const [questions, setQuestions] = useState<string[]>([]);
  const enabled = opts.enabled;
  const source = opts.source;

  function refresh(question: string, answer: string): void {
    if (!enabled || question === "" || answer === "") return;
    void fetchFollowUpQuestions(source, question, answer).then((next) => {
      if (next.length > 0) setQuestions(next);
    });
  }

  function clear(): void {
    setQuestions([]);
  }

  return { questions, clear, refresh };
}
